import React, { Component } from 'react';

import '../css/galeria.css'
import matriz from '../img/padilla-matriz.jpg'

class Galeria extends Component {
  render() {
    return (
      <div className="container mt-4">
        <div className="fotofondo row p-4 p-md-5 no-gutters">
          <div className="col">
            <img className="img-fluid" src={matriz} alt=""/>
          </div>
        </div>
      </div>
    )
  }
}

export default Galeria;
